const translations = {
  AA: 'A/A',
  ACCEPTANCE: 'Accept',
  ACCEPTED_OFFER: 'Accepted Offer',
  ACTIVATION: 'Activate',
  ACTIVATE_DEACTIVATE: 'Activate\\Deactivate',
  ACTIVE: 'Active',
  ACTIVE_C: 'ACTIVE',
  ACTIVE_FEM: 'Active',
  ACTIVE_PL: 'Active',
  ACTIVE_PL_FEM: 'Active',
  ACTIVΙΤΥ: 'Activity',
  ADDITION: 'Add',
  ADDRESS: 'Address',
  ADDRESSES: 'Addresses',
  AGENT_C: 'MERCHANT',
  ALL: 'All',
  AMOUNT: 'Amount',
  AMOUNT_GREATER_THAN_ZERO: 'The amount must be greater than zero.',
  AMOUNTS: 'Amounts',
  APPS_MEMBERSHIPS: 'APPLICATIONS - MEMBERSHIPS',
  APPROVAL: 'Approve',
  APPROVED_DOCS: 'Approved Documents',
  ARE_YOU_SURE: 'Are you sure?',
  AUCTION: 'Auction',
  AUCTION_APPROVAL: 'Auction Approval',
  AUCTION_CANCEL: 'Cancel auction',
  AUCTION_CANCELED: 'The auction has been canceled',
  AUCTION_CANCEL_ALL: 'Bulk cancellation',
  AUCTION_CANCEL_FOR: 'You are going to cancel auction for ',
  AUCTION_CANCEL_ALL_ASK: 'You are going to cancel all selected auctions.',
  AUCTION_CREATE_C: 'NEW AUCTION',
  AUCTION_DURATION: 'Auction Duration',
  AUCTION_ENDED: 'Auction ended',
  AUCTION_INFO: 'Auction Info',
  AUCTIONS_LOSING: 'Auctions I am losing',
  AUCTIONS_LOSING_C: 'AUCTION I AM LOSING',
  AUCTIONS_NEW: 'New Auctions',
  AUCTIONS_NEW_C: 'NEW AUCTIONS',
  AUCTIONS_NEW_DESCRIPTION: 'There are new actions since your last login.',
  AUCTION_NOT_STARTED_YET: 'Auction has not started yet.',
  AUCTION_SELECT_LOWEST_PRICES_ALL: 'Bulk Selection',
  AUCTION_SELECT_LOWEST_PRICES_ALL_ASK:
    'You are going to choose the lowest prices from selected part types for all selected auctions.',
  AUCTION_SELECT_BEST_PRICES_ALL_ASK:
    'You are going to choose the highest prices for all selected auctions.',
  AUCTION_STATUS_CANCELED: 'Canceled',
  AUCTION_STATUS_DELETED: 'Deleted',
  AUCTION_STATUS_FINISHED: 'Ended',
  AUCTION_STATUS_FINISHING_IN: 'Ending in ',
  AUCTION_STATUS_FOR_ACCEPTANCE: 'For acceptance',
  AUCTION_STATUS_FOR_DELIVERY: 'For Shipment',
  AUCTION_STATUS_OVERDUE: 'Ended',
  AUCTION_STATUS_PENDING: 'Pending',
  AUCTIONS: 'Auctions',
  AUCTIONS_CHOSEN: 'Chosen Auctions',
  AUCTIONS_MY_C: 'MY AUCTIONS',
  AUCTIONS_WINNING: 'Auctions I am winning',
  AUCTIONS_WINNING_C: 'AUCTIONS I AM WINNING',
  AUCTION_TITLE: 'Title',
  BASIC_INFO: 'Basic Info',
  BID_FROM: 'Bid From',
  BID_TO: 'Bid To',
  BID_STEP: 'Bid Step',
  BEST_OFFER: 'BEST OFFER',
  BRAND: 'Brand',
  BRANDS: 'Brands',
  CANCEL: 'Cancel',
  CANCEL_C: 'CANCEL',
  CANCELLATION: 'Cancel',
  CANCELLATION_REASON: 'Cancellation Reason',
  CATEGORY: 'Category',
  CAR_DATA: 'Car Info',
  CHANGE_C: 'CHANGE',
  CHANGE_PASSWORD: 'Change Password',
  CHANGE_PASSWORD_C: 'CHANGE PASSWORD',
  CHOOSE_EXISTING: 'Choose Existing',
  CHOOSE_PREFECTURE: 'Choose Prefecture',
  CHOOSE_VALUE: 'Choose Price',
  CITY: 'City',
  CLICKABLE_OFFERS: 'Clickable Offers',
  CLOSE: 'Close',
  COMPLETED: 'Completed',
  COMPLETED_PL_FEM: 'Completed',
  COMMENTS: 'Comments',
  COMMUNICATION_NAME: 'Com. Name',
  COMMUNICATION_SURNAME: 'Com. Surname',
  CONFIRM_RESET_PROCESSING_ESTIMATIONS:
    'Are you sure to update processing estimations to pending?',
  CONFIRM_RERUN_ESTIMATION:
    'Are you want to update the platform with the new estimations?',
  CONFIRM_RUN_FAILED_ESTIMATION:
    'Are you sure you want to rerun the failed estimations?',
  CONFIRM_RUN_PENDING_ESTIMATION:
    'Are you sure you want to run the pending estimations?',
  COPY: 'Copy',
  COST_PER_FOLDER: 'Cost Per Folder',
  COUNTRY: 'Country',
  CREATE_FROM: 'Created from',
  CREATE_NEW: 'Create New',
  CREATE_NEW_FEM: 'Create New',
  CURRENT: 'Current',
  CURRENT_AUCTIONS_C: 'CURRENT',
  DASHBOARD: 'Dashboard',
  DATAGRID_CHOOSE: 'Choose',
  DATAGRID_FIRST: 'First',
  DATAGRID_FROM_PAGE: 'from',
  DATAGRID_LAST_PAGE: 'Last',
  DATAGRID_NEXT_PAGE: 'Next',
  DATAGRID_NO_RESULTS: 'No Results',
  DATAGRID_PAGE: 'Page',
  DATAGRID_PREVIOUS_PAGE: 'Previous',
  DATAGRID_RESULTS_PER_PAGE: 'Results per page',
  DATAGRID_RESULTS_UNTIL_PAGE: 'until',
  DATAGRID_SEARCH: 'Search...',
  DATE: 'Date',
  DATE_FROM: 'Date From',
  DATE_UNTIL: 'Date Until',
  DATE_OVERDUE: 'End Date',
  DATE_CREATION: 'Creation Date',
  DATE_MODIFICATION: 'Modification Date',
  DATE_CREATION_SHORT: 'Creation Date',
  DATE_MODIFICATION_SHORT: 'Modification Date',
  DATE_LAST_RUN: 'Last Run Date',
  DATE_LAST_RUN_SHORT: 'Last Run Date',
  DAY: 'Day',
  DAYS: 'Days',
  DAYS_MISSING_ENDING: 'day',
  DAY_NO_ENDING: 'Day',
  DEACTIVATED: 'Deactivated',
  DEACTIVATION: 'Deactivate',
  DEBT: 'Debt',
  DELETE: 'Delete',
  DELETE_SELECTED_CONFIRMATION: 'Are you sure you want to delete the selected?',
  DELETE_SELECTED_CONFIRMATION_PL:
    'Are you sure you want to delete the selected?',
  DELETION: 'Deletion',
  DELIVERY: 'Ship',
  DEFAULT_INSURANCE_DAYS: 'Auction Days',
  DESCRIPTION: 'Description',
  DETAILS: 'Details',
  DIFFERENCE_FROM_MARKET_VALUE: 'Dif. From Market Value',
  DIFFERENCE_FROM_INITIAL_PRICE: 'Dif. From Initial Price',
  DISPATCH: 'Ship',
  DISPATCH_PROBLEM: 'Ship Problem',
  DISTINCTIVE_TITLE: 'Distinct.Title',
  DOORS: 'Doors',
  DRAG_FILES_TO_AREA: 'Drag files to area',
  DURATION: 'Duration',
  EDIT: 'Edit',
  EMAIL: 'Email',
  EMPTY: '<Empty>',
  ENGINE_TYPE: 'Engine Type',
  ENGINE_CAPACITY: 'Engine Capacity',
  END: 'End',
  END_DATE: 'End Date',
  END_DATE_AUCTION: 'Auction End Date',
  ENDING_FEMALE_SINGULAR: ' ',
  ENDING_FEMALE_PLURAL: 's',
  EPICS_APP_SUCCESFUL_CHANGE_PASSWORD: 'Succesful password change.',
  EPICS_APP_SUCCESFUL_RESET_PASSWORD: 'The password reseted.',
  EPICS_AUCTIONS_ACCEPTED_INSURANCE_OFFER: 'Accepted the offer.',
  EPICS_AUCTIONS_AUCTION_CANCELED: 'Auction cancelled!',
  EPICS_AUCTIONS_AUCTION_CREATED: 'Auction created!',
  EPICS_AUCTIONS_AUCTION_EDITED: 'Auction edited',
  EPICS_AUCTIONS_AUCTION_STARTED: 'Auction activated!',
  EPICS_AUCTIONS_FILE_LOAD: 'The file uploaded',
  EPICS_AUCTIONS_LOWEST_PRICES_FROM_SELECTED:
    'Lowest offers chosen from selected auctions.',
  EPICS_AUCTIONS_BEST_PRICES_FROM_SELECTED:
    'Best offers chosen from selected auctions.',
  EPICS_AUCTIONS_OFFER_INSERTED: 'Offer saved!',
  EPICS_AUCTIONS_OFFER_SELECTED: 'Offer selected!',
  EPICS_AUCTIONS_OFFER_REJECTED: 'Offer rejected!',
  EPICS_AUCTIONS_SUCCESFUL_UPDATE: 'Succesful update!',
  EPICS_BIDS_BID_CANCELED: 'Offer cancelled!',
  EPICS_GARAGES_GARAGE_CREATED: 'Garage created!',
  EPICS_GARAGES_GARAGE_UPDATED: 'Garage updated!',
  EPICS_GARAGES_GARAGE_DELETED: 'Garage deleted!',
  EPICS_PARTIES_PARTY_CREATED: 'Party created!',
  EPICS_PARTIES_PARTY_UPDATED: 'Party updated!',
  EPICS_PARTIES_PARTY_DELETED: 'Party deleted!',
  EPICS_PARTIES_STATUS_UPDATE: 'Party status changed',
  ESTIMATIONS: 'Estimations',
  ESTIMATIONS_CHOSEN: 'Chosen Estimations',
  ESTIMATIONS_C: 'ESTIMATIONS',
  ESTIMATIONS_NEW_C: 'NEW ESTIMATIONS',
  ESTIMATIONS_UPDATE: 'Update estimations',
  ESTIMATIONS_RUN: 'Process estimations',
  ESTIMATIONS_RESET: 'Reset estimations',
  EXPERT: 'Expert',
  EXPERT_SHORT: 'Expert',
  EXPERTS: 'Experts',
  FAILED: 'Failed',
  FAILED_FEM: 'Failed',
  FAILED_FEM_C: 'FAILED',
  FAILED_REASON: 'Failed Reason',
  FAX: 'Fax',
  FEE: 'Fee',
  FEE_AMOUNT: 'Fee Amount',
  FEE_PERCENTAGE: 'Fee Percentage',
  FEES: 'Fees',
  FEES_POLICY: 'Fees Policy',
  FIELD_CANNOT_BE_EMPTY: 'Field cannot be null',
  FIELD_DOORS_CANNOT_BE_ONE: 'Door number cannot be 1',
  FIELD_POSITIVE_NUMBER: 'Field must be positive number',
  FINISHED: 'Finished',
  FIRSTNAME: 'Name',
  FOLDER_NO: 'Folder No',
  FOLDER_C: 'FOLDER',
  FOLDER_COUNT: 'Folder Count',
  FOLDER_DATA: 'Folder Info',
  FOR: 'for',
  FOR_ACCEPTANCE: 'For Acceptance',
  FOR_DISPATCH: 'For Shipment',
  FOR_SELECTION: 'For Selection',
  FRAME_NUMBER: 'Frame Number',
  FROM: 'From',
  FROM_FILE: 'From File',
  GARAGE_C: 'GARAGE',
  GARAGE_ASK_TO_CHOOSE: 'Please select a garage.',
  GARAGE_CHOOSE: 'Garage Selection',
  GARAGE_CREATE: 'Garage Creation',
  GARAGE_DELETE: 'Garage Deletion',
  GARAGE_EDIT_C: 'EDIT GARAGE',
  GARAGE_NEW_C: 'CREATE GARAGE',
  GARAGES: 'Garages',
  GARAGE_TAX_NUMBER: 'Garage Tax Number',
  GEARBOX: 'Gearbox',
  GENERAL: 'General',
  GENERIC_ERROR: 'An error occured',
  HIDE: 'Hide',
  HIDE_C: 'HIDE',
  HISTORY: 'History',
  HOURS: 'hours',
  HOURS_MISSING_ENDING: 'hour',
  IF_INSERTED_GARAGE:
    'If you have already inserted your affiliate garage, type its tax number, else inserted with the button below.',
  IMAGES_UPLOAD: 'Upload Images',
  IMITATION_CATEGORY: 'After Market Cat.',
  INACTIVE_C: 'INACTIVE',
  INFO: 'INFO',
  INITIAL_PRICE_SHORT: 'In.Price',
  INPUT_DATA: 'Data Input',
  INSURANCE: 'Insurance',
  INSURANCE_C: 'INSURANCE',
  INSURANCE_PARTNERS: 'Coll.Insurances',
  INSURANCES: 'Insurances',
  KEEPED_FOR: 'Commited for ',
  KILOMETERS: 'Kilometers',
  LAST_RUN_DATE: 'Last Run Date',
  LICENSE_PLATE_BLUR: 'License Plate Blur',
  LIST: 'List',
  LOG_INTO_APPLICATION: 'Log into Application',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  LOSES: 'Loses',
  MANAGE: 'Manage',
  MARKET_VALUE: 'Market Value',
  MAX_LIMIT_OF_PHOTOS_REACHED: 'Max limit of photos:',
  MEMBERSHIP: 'Membership',
  MERCHANT: 'Merchant',
  MERCHANTS: 'Merchants',
  MERCHANT_OFFER: 'Merchant Offer',
  MERCHANT_FEE_SAVED: 'Merchant fee saved succesfully',
  MERCHANT_FEES: 'Merchant Fees',
  MINUTES: 'Minutes',
  MOBILE: 'Mobile',
  MODAL_QUESTION_OFFER_DELETE: 'Your offer will be deleted. Are you sure?',
  MODAL_QUESTION_AUCTION_CANCEL: 'Auction will be canceled. Are you sure?',
  MODAL_QUESTION_OFFER_REJECT: 'Do you want to reject your offer?',
  MODAL_QUESTION_PARTS_SENT: 'Have you shipped parts?',
  MODAL_QUESTION_PARTS_SENT_PROBLEM: 'is there a problem with parts shipping?',
  MODAL_QUESTION_GARAGE_DELETE: 'You are going to delete the garage ',
  MODAL_QUESTION_PARTY_DELETE: 'You are going to delete the party ',
  MODAL_QUESTION_PASSWORD_RESET: 'You are going to  reset the  password of ',
  MODAL_QUESTION_PARTY_ACTIVATE: 'You are going to activate the party ',
  MODAL_QUESTION_PARTY_DEACTIVATE: 'You are going to deactivate the party ',
  MODEL: 'Model',
  MONTH_JAN: 'Jan',
  MONTH_FEB: 'Feb',
  MONTH_MAR: 'Mar',
  MONTH_APR: 'Apr',
  MONTH_MAY: 'May',
  MONTH_JUN: 'Jun',
  MONTH_JUL: 'Jul',
  MONTH_AUG: 'Aug',
  MONTH_SEP: 'Sep',
  MONTH_OCT: 'Oct',
  MONTH_NOV: 'Nov',
  MONTH_DEC: 'Dec',
  MORE: 'More',
  NEW: 'NEW',
  NEW_PL: 'NEW',
  NEW_FEMALE: 'NEW',
  NEW_FEMALE_PL: 'NEW',
  NEW_FEMALE_PL_C: 'NEW',
  NO: 'No',
  NO_OFFER: 'No Offer',
  NO_BEST_OFFER: 'Not Best Offer',
  NO_OFFER_PLACED: 'THERE IS NO OFFER PLACED',
  NO_OFFERS_CONTINUE: ' no offers.',
  NO_OPTIONS: 'No options',
  NOT_AUTHORIZED_TO_VIEW_PAGE: 'You are not authorized to view this page.',
  NOT_VALID_AFM: 'Tax Number is not valid.',
  NOT_VALID_AFM_TEMP: 'Tax Number cannot have more than 10 digits.',
  NOT_VALID_EMAIL: 'Email is not valid.',
  NUMBER: 'Number',
  NAME_SURNAME: 'Name',
  OFFER: 'Offer',
  OFFER_ACCEPTED_RESPONE: 'Insurance chosed your offer! Pleaze accept.',
  OFFER_APPROVE: 'Accept Offer',
  OFFER_REJECT: 'Reject Offer',
  OFFER_APPROVE_ASK: 'Are you accepting the offer?',
  OFFER_C: 'OFFER',
  OFFER_CHOOSE_FOR: 'You have select offer for ',
  OFFER_CHOSEN_FOR: 'Offer has been chosed for ',
  OFFER_CHOSE_ONE_FROM_THEM: 'Select one of the offers below.',
  OFFER_NEW: 'New Offer',
  OFFER_NEW_C: 'NEW OFFER',
  OFFER_SELECTION: 'Offer Selection',
  OFFER_FOR: 'Offer for ',
  OFFER_ALREADY: 'You have already done an offer ',
  OFFER_ALREADY_FOR: 'You have already done an offer for ',
  OFFER_WILL_BE_REPLACED: '. If you continue your old offer will be replaced.',
  OFFER_STATUS: 'Offer Status',
  OFFERS: 'Offers',
  OFFERS_C: 'OFFERS',
  OFFERS_MARKET_VALUE_C: 'OFFERS - MARKET VALUE: ',
  OFFERS_INITIAL_PRICE_C: 'OFFERS - INITIAL PRICE: ',
  OFFERS_TO_AUCTIONS_C: 'OFFERS FOR AUCTIONS',
  OFFER_PLACEMENT: 'Position',
  OFFER_PLACEMENT_C: 'POSITION',
  OFFER_SMALLER_THAN_3RD: '< 3',
  OFFER_COMMITMENT_UNTIL: 'Offer commitment until:',
  OFFER_COMMITMENT_UNTIL_C: 'OFFER COMMITMENT UNTIL:',
  LIVE: 'LIVE',
  OVERDUE: 'Ended',
  OWNER_INFO: 'Owner Info',
  OWNER_INFO_INSERT: 'Insert owner΄s info',
  PAYMENT: 'Payment',
  PAYMENT_DATE: 'Payment Date',
  PART_C: 'PART',
  PART_DATA: 'Part Info',
  PART_NO: 'Part No',
  PART_NUMBER: 'Part Number',
  PART_SEND: 'Ship Parts',
  PART_SEND_PROBLEM: 'Problem with part shipping',
  PART_SEND_FINISHED_ASK: 'Part shipping is completed?',
  PART_TYPE: 'Type',
  PART_TYPE_LONG: 'Part Type',
  PART_TYPE_IMITATION: 'After Market',
  PART_TYPE_IMITATION_SHORT: 'AFTM',
  PART_TYPE_NEW: 'New',
  PART_TYPE_NEW_PL: 'New',
  PART_TYPE_NEW_SHORT: 'NEW',
  PART_TYPE_USED: 'Used',
  PART_TYPE_USED_PL: 'Used',
  PART_TYPE_USED_SHORT: 'USD',
  PART_TYPES: 'Part Types',
  PART_WITH_PRICE: ' part with price ',
  PARTIES: 'Parties',
  PARTICIPATE_TO: 'Participate To',
  PARTS: 'Parts',
  PARTS_C: 'PARTS',
  PARTS_PER_FOLDER: 'Parts per folder',
  PARTS_DELIVERY: 'Parts have been shipped.',
  PARTS_DELIVERY_PROBLRM:
    'There is a problem with part shipping. See comments.',
  PARTY_EDIT_C: 'PARTY EDIT',
  PARTY_DELETE: 'Delete Party',
  PARTY_NEW_C: 'NEW PARTY',
  PARTY_STATUS: 'Status',
  PARTY_TYPE: 'Type',
  PASSWORD: 'Password',
  PASSWORD_NEW: 'New password',
  PASSWORD_OLD: 'Old password',
  PENDING_APPROVAL: 'Pending Approval',
  PENDING: 'Pending',
  PENDING_C: 'PENDING',
  PER_BRAND: 'Per Brand',
  PER_EXPERT: 'Per Expert',
  PER_INSURANCE: 'Per Insurance',
  PER_MODEL: 'Per Model',
  PER_PART_TYPE: 'Per Part Type',
  PER_REGION: 'Per Region',
  PERIOD: 'Period',
  PERIOD_WEEKLY: 'Weekly',
  PERIOD_MONTHLY: 'Monthly',
  PERIOD_QUARTERLY: 'Quarterly',
  PERIOD_THIRD_YEARLY: 'Tertile',
  PERIOD_HALF_YEARLY: 'Half Yearly',
  PERIOD_YEARLY: 'Yearly',
  PROCESSING: 'Processing',
  PROCESSING_C: 'PROCESSING',
  PROFILE: 'Profile',
  PROFILE_C: 'PROFILE',
  PROPOSED_MARKET_VALUE: 'Indicative Market Value',
  POSTALCODE: 'Postal Code',
  PHONE: 'Phone',
  PHONE_SHORT: 'Ph',
  PHOTOS: 'Photos',
  PLACEMENT: 'Placement',
  PLATE: 'Plate',
  PLATE_NUMBER: 'Plate Number',
  PREFECTURE: 'Prefecture',
  PRICE: 'Price',
  PRICE_IMITATION: 'Price After Market',
  PRICE_IMITATION_TARGET: 'Sug. Price After Market',
  PRICE_NEW: 'Price New',
  PRICE_NEW_TARGET: 'Sug. Price New',
  PRICE_USED: 'Price Used',
  PRICE_USED_TARGET: 'Sug. Price Used',
  QUANTITY: 'Quantity',
  REASON: 'Reason',
  REGISTRATION_YEAR: 'Registr. Year',
  REGION: 'Prefecture',
  REGIONS: 'Prefectures',
  REJECTED_PL_FEM: 'Rejected',
  REJECTION: 'Reject',
  REMAINING_TIME_SHORT: 'Rem. Time',
  REORDER: 'Reorder',
  REPORT_NO_BRAND: '<No Brand>',
  REPORT_NO_EXPERT: '<No Expert>',
  REPORT_NO_INSURANCE: '<No Insurance>',
  REPORT_NO_REGION: '<No Prefecture>',
  REPORTS: 'Statistics',
  RESET_PASSWOD: 'Reset Password',
  RESTART: 'Restart',
  RETRY_NUM: 'Retry Num',
  RETURN: 'Return',
  RUN: 'Run',
  RUN_FORCE: 'Force Run',
  RUN_SELECTED_CONFIRMATION: 'Are you sure you want to run the selected?',
  RUN_SELECTED_CONFIRMATION_PL: 'Are you sure you want to run the selected?',
  SAVE: 'Save',
  SAVE_INPUT: 'Save',
  SECONDS: 'Seconds',
  SELECT: 'Select',
  SELECT_C: 'SELECT',
  SELECTION: 'Select',
  SEMESTER_COUNT: ' semester ',
  SETTINGS: 'Settings',
  SMALL_DAMAGE: 'Small Damage',
  SMALL_DAMAGE_C: 'SMALL DAMAGE',
  SN: 'SN',
  STATUS: 'Status',
  STREET: 'Street',
  SUCCEED: 'Succeed',
  SUM_INITIAL_PRICE: 'Initial Price Sum',
  SUM: 'Sum',
  SURNAME: 'Surname',
  TAXNUMBER: 'Tax Number',
  TAXOFFICE: 'Tax Office',
  TITLE: 'Title',
  TODAY: 'Today',
  TOMORROW: 'Tommorow',
  TOTAL: 'Total',
  TOTAL_C: 'Total',
  TOTAL_AMOUNT: 'Total Amount',
  UPDATE_ESTIMATIONS_C: 'UPDATE ESTIMATIONS',
  UPGRADE_SILVER_MEMBERSHIP:
    'In order to bid cars with market value over 7000€, you must upgrade your membership. For informations contact our company.',
  UPGRADE_GOLDEN_MEMBERSHIP:
    'In order to see your bid placement and the best offer, you must upgrade your membership. For informations contact our company.',
  USED_CONDITION_TYPE: 'Used Category',
  USERNAME: 'Username',
  VDPARTS: 'VD-Parts',
  VDCARS: 'VD-Cars',
  VDFM_INFO: 'Info',
  VEHICLE_TYPE: 'Vehicle Type',
  VEHICLE_TYPE_SHORTENED: 'Veh. Type',
  VIEW_ALL: 'View All',
  VIEW_ALL_C: 'VIEW ALL',
  YEAR_CREATED: 'Release Year',
  YES: 'Yes',
  WAITING_SELECTION_FROM_INSURANCE: 'Waiting selection from insurance',
  WAITING_FOR_ACCEPT_FROM_MERCHANT: 'Waiting for acceptance from merchant.',
  WHEELDRIVE: 'Wheeldrive',
  WINNINGS: 'Winnings',
  WINS: 'Wins',
  WITH_INITIAL_PRICE: 'with initial price',
  WITHOUT_OFFER: 'No offer',
  WRONG_USERNAME_OR_PASSWORD: 'Wrong username or password.',

  //CancellationReasons
  WILL_BE_REPAIRED: 'Will be repaired',
  OWNER_WILL_KEEP_IT: 'Owner will keep it',
  NOT_FRIENDLY: 'Not friendly',
  WILL_BE_JUDGED: 'Will be judged',
  OTHER: 'Other',

  //UsedConditionTypes
  PERFECT: 'Perfect',
  VERY_GOOD: 'Very good',
  FUNCTIONAL: 'Functional',
  NEED_REPAIR: 'Need repair',

  //ImitationPartCategories
  CATEGORY_A: 'A Category',
  CATEGORY_B: 'B Category',

  //PREFECTURES
  ATTIKI: 'ATTIKI',
  THESSALONIKIS: 'THESSALONIKIS',
  ACHAIAS: 'ACHAIAS',
  HERAKLION: 'HERAKLION',
  LARISAS: 'LARISAS',
  AITOLOAKARNANIAS: 'AITOLOAKARNANIAS',
  EVOIAS: 'EVOIAS',
  MAGNISIAS: 'MAGNISIAS',
  SERRON: 'SERRON',
  ILIAS: 'ILIAS',
  DODEKANISOU: 'DODEKANISOU',
  FTHIOTIDAS: 'FTHIOTIDAS',
  MESSINIAS: 'MESSINIAS',
  IOANNINON: 'IOANNINON',
  KOZANIS: 'KOZANIS',
  KORINTHIAS: 'KORINTHIAS',
  CHANION: 'CHANION',
  EVROU: 'EVROU',
  PELLAS: 'PELLAS',
  KAVALAS: 'KAVALAS',
  IMATHIAS: 'IMATHIAS',
  TRIKALON: 'TRIKALON',
  VIOTIAS: 'VIOTIAS',
  PIERIAS: 'PIERIAS',
  KARDITSAS: 'KARDITSAS',
  KYKLADON: 'KYKLADON',
  KERKYRAS: 'KERKYRAS',
  RODOPIS: 'RODOPIS',
  LESVOU: 'LESVOU',
  ARGOLIDAS: 'ARGOLIDAS',
  CHALKIDIKIS: 'CHALKIDIKIS',
  DRAMAS: 'DRAMAS',
  ARKADIAS: 'ARKADIAS',
  XANTHIS: 'XANTHIS',
  LAKONIAS: 'LAKONIAS',
  KILKIS: 'KILKIS',
  RETHIMNOU: 'RETHIMNOU',
  ARTAS: 'ARTAS',
  LASITHIOU: 'LASITHIOU',
  PREVEZAS: 'PREVEZAS',
  FLORINAS: 'FLORINAS',
  KASTORIAS: 'KASTORIAS',
  CHIOU: 'CHIOU',
  FOKIDAS: 'FOKIDAS',
  THESPROTIAS: 'THESPROTIAS',
  SAMOU: 'SAMOU',
  KEFALLINIAS: 'KEFALLINIAS',
  ZAKINTHOU: 'ZAKINTHOU',
  GREVENON: 'GREVENON',
  EVRITANIAS: 'EVRITANIAS',
  LEFKADAS: 'LEFKADAS',
  FAMAGUSTA: 'FAMAGUSTA',
  KYRENIA: 'KYRENIA',
  LARNACA: 'LARNACA',
  LIMASSOL: 'LIMASSOL',
  NICOSIA: 'NICOSIA',
  PAPHOS: 'PAPHOS',

  //Countries
  ANDORRA: 'ANDORRA',
  UNITED_ARAB_EMIRATES: 'UNITED ARAB EMIRATES',
  AFGHANISTAN: 'AFGHANISTAN',
  ANTIGUA_AND_BARBUDA: 'ANTIGUA AND BARBUDA',
  ANGUILLA: 'ANGUILLA',
  ALBANIA: 'ALBANIA',
  ARMENIA: 'ARMENIA',
  NETHERLANDS_ANTILLES: 'NETHERLANDS ANTILLES',
  ANGOLA: 'ANGOLA',
  ARGENTINA: 'ARGENTINA',
  AMERICAN_SAMOA: 'AMERICAN SAMOA',
  AUSTRIA: 'AUSTRIA',
  AUSTRALIA: 'AUSTRALIA',
  ARUBA: 'ARUBA',
  AZERBAIJAN: 'AZERBAIJAN',
  BOSNIA_AND_HERZEGOVINA: 'BOSNIA HERZEGOVINA',
  BARBADOS: 'BARBADOS',
  BANGLADESH: 'BANGLADESH',
  BELGIUM: 'BELGIUM',
  BURKINA_FASO: 'BURKINA FASO',
  BULGARIA: 'BULGARIA',
  BAHRAIN: 'BAHRAIN',
  BURUNDI: 'BURUNDI',
  BENNIN: 'BENNIN',
  SHORTS: 'SHORTS',
  BRUNEI_DARUSSALAM: 'BRUNEI DARUSSALAM',
  BOLIVIA: 'BOLIVIA',
  BRAZIL: 'BRAZIL',
  BAHAMAS: 'BAHAMAS',
  BHUTAN: 'BHUTAN',
  BOUVET_ISLAND: 'BOUVET ISLAND',
  BOTSWANA: 'BOTSWANA',
  BELARUS: 'BELARUS',
  BELIZE: 'BELIZE',
  CANADA: 'CANADA',
  KILLINGK_ISLANDS: 'KILLINGK ISLANDS',
  DEMOCRATIC_REPUBLIC_OF_CONGO: 'DEMOCRATIC REPUBLIC OF CONGO',
  CENTRAL_AFRICA: 'CENTRAL AFRICA',
  CONGO: 'CONGO',
  SWITZERLAND: 'SWITZERLAND',
  IVORY_COAST: 'IVORY COAST',
  COOK_ISLANDS: 'COOK ISLANDS',
  CHILE: 'CHILE',
  CAMEROON: 'CAMEROON',
  CHINA: 'CHINA',
  COLOMBIA: 'COLOMBIA',
  COSTA_RICA: 'COSTA RICA',
  CUBA: 'CUBA',
  CAPE_VERDE: 'CAPE VERDE',
  CHRISTMAS_ISLAND: 'CHRISTMAS ISLAND',
  CYPRUS: 'CYPRUS',
  CZECH_REPUBLIC: 'CZECH REPUBLIC',
  GERMANY: 'GERMANY',
  DJIBOUTI: 'DJIBOUTI',
  DENMARK: 'DENMARK',
  DOMINICA: 'DOMINICA',
  DOMINICAN_REPUBLIC: 'DOMINICAN REPUBLIC',
  ALGERIA: 'ALGERIA',
  ECUADOR: 'ECUADOR',
  ESTONIA: 'ESTONIA',
  EGYPT: 'EGYPT',
  WEST_SAHARA: 'WEST SAHARA',
  SPAIN: 'SPAIN',
  AITHIOPOIA: 'AITHIOPOIA',
  FINLAND: 'FINLAND',
  FIJI: 'FIJI',
  GREECE: 'GREECE',
  FALKLAND_ISLANDS: 'FALKLAND ISLANDS',
  MICRONESIA: 'MICRONESIA',
  AEGEAN_ISLANDS: 'AEGEAN ISLANDS',
  FRANCE: 'FRANCE',
  GABON: 'GABON',
  UNITED_KINGDOM: 'UNITED KINGDOM',
  GRENADA: 'GRENADA',
  GEORGIA: 'GEORGIA',
  FRENCH_GUYANA: 'FRENCH GUYANA',
  GKOUERNSEF: 'GKOUERNSEF',
  GHANA: 'GHANA',
  GIBRALTAR: 'GIBRALTAR',
  GREENLAND: 'GREENLAND',
  GAMBIA: 'GAMBIA',
  GUINEA: 'GUINEA',
  GUADELOUPE: 'GUADELOUPE',
  EQUATORIAL_GUINEA: 'EQUATORIAL GUINEA',
  GUATEMALA: 'GUATEMALA',
  GUAM: 'GUAM',
  GUINEA_BISSAU: 'GUINEA BISSAU',
  GUYANA: 'GUYANA',
  HONG_KONG: 'HONG KONG',
  HEARD_ISLAND_AND_McDONALD_ISLAND: 'HEARD ISLAND AND McDONALD ISLAND',
  HONDURAS: 'HONDURAS',
  CROATIA: 'CROATIA',
  HAITI: 'HAITI',
  HUNGARY: 'HUNGARY',
  INDONESIA: 'INDONESIA',
  IRELAND: 'IRELAND',
  ISRAEL: 'ISRAEL',
  ISLE_OF_MAN: 'ISLE OF MAN',
  INDIA: 'INDIA',
  BRITISH_INDIAN_OCEAN_REGION: 'BRITISH INDIAN OCEANREGION',
  IRAQ: 'IRAQ',
  IRAN: 'IRAN',
  ICELAND: 'ICELAND',
  ITALY: 'ITALY',
  JERSEY: 'JERSEY',
  JAMAICA: 'JAMAICA',
  JORDAN: 'JORDAN',
  JAPAN: 'JAPAN',
  KENYA: 'KENYA',
  KYRGISTAN: 'KYRGISTAN',
  CAMBODIA: 'CAMBODIA',
  KIRIBATI: 'KIRIBATI',
  COMOROS: 'COMOROS',
  SAINT_KITTS_AND_NEVIS: 'SAINT KITTS AND NEVIS',
  NORTH_KOREA: 'NORTH KOREA',
  SOUTH_KOREA: 'SOUTH KOREA',
  KUWAIT: 'KUWAIT',
  Cayman_ISLANDS: 'Cayman ISLANDS',
  KAZAKHSTAN: 'KAZAKHSTAN',
  LAOS: 'LAOS',
  LEBANON: 'LEBANON',
  SAINT_LUCIA: 'SAINT LUCIA',
  LIECHTENSTEIN: 'LIECHTENSTEIN',
  SRI_LANKA: 'SRI LANKA',
  LIBERIA: 'LIBERIA',
  LESOTHO: 'LESOTHO',
  LITHUANIA: 'LITHUANIA',
  LUXEMBOURG: 'LUXEMBOURG',
  LATVIA: 'LATVIA',
  LIBYA: 'LIBYA',
  MOROCCO: 'MOROCCO',
  MONACO: 'MONACO',
  MOLDOVA: 'MOLDOVA',
  MONTENEGRO: 'MONTENEGRO',
  MADAGASCAR: 'MADAGASCAR',
  MARSHALL_ISLANDS: 'MARSHALL ISLANDS',
  FYR_of_MACEDONIA: 'SCOPIA',
  MALI: 'MALI',
  MYANMAR: 'MYANMAR',
  MONGOLIA: 'MONGOLIA',
  MACAU: 'MACAU',
  NORTHERN_ISLANDS_MARIANNES: 'NORTHERN ISLANDS MARIANNES',
  MARTINIQUE: 'MARTINIQUE',
  MAURITANIA: 'MAURITANIA',
  MONTSERRAT: 'MONTSERRAT',
  MALTA: 'MALTA',
  MAURITIUS: 'MAURITIUS',
  MALDIVES: 'MALDIVES',
  MALAWI: 'MALAWI',
  MEXICO: 'MEXICO',
  MALAYSIA: 'MALAYSIA',
  MOZAMBIQUE: 'MOZAMBIQUE',
  NAMIBIA: 'NAMIBIA',
  NEW_CALEDONIA: 'NEW CALEDONIA',
  NIGER: 'NIGER',
  NORFOLK_ISLAND: 'NORFOLK ISLAND',
  NIGERIA: 'NIGERIA',
  NICARAGUA: 'NICARAGUA',
  NETHERLANDS: 'NETHERLANDS',
  NORWAY: 'NORWAY',
  NEPAL: 'NEPAL',
  NAURU: 'NAURU',
  NIUE: 'NIUE',
  NEW_ZEALAND: 'NEW ZEALAND',
  OMAN: 'OMAN',
  PANAMA: 'PANAMA',
  PERU: 'PERU',
  FRENCH_POLYNESIA: 'FRENCH POLYNESIA',
  PAPUA_NEW_GUINEA: 'PAPUA NEW GUINEA',
  PHILIPPINES: 'PHILIPPINES',
  PAKISTAN: 'PAKISTAN',
  POLAND: 'POLAND',
  SAINT_PIERRE_AND_MIQUELON: 'SAINT PIERRE AND MIQUELON',
  PITCAIRN: 'PITCAIRN',
  PUERTO_RICO: 'PUERTO RICO',
  PALESTINE: 'PALESTINE',
  PORTUGAL: 'PORTUGAL',
  PALAU: 'PALAU',
  PARAGUAY: 'PARAGUAY',
  QATAR: 'QATAR',
  REUNIFICATION_ISLANDS: 'REUNIFICATION ISLANDS',
  ROMANIA: 'ROMANIA',
  SERBIA: 'SERBIA',
  RUSSIA: 'RUSSIA',
  RWANDA: 'RWANDA',
  SAUDI_ARABIA: 'SAUDI ARABIA',
  SOLOMONTA_ISLANDS: 'SOLOMONTA ISLANDS',
  SEYCHELLES: 'SEYCHELLES',
  SUDAN: 'SUDAN',
  SWEDEN: 'SWEDEN',
  SINGAPORE: 'SINGAPORE',
  SAINT_HELENA: 'SAINT_HELENA',
  SLOVENIA: 'SLOVENIA',
  SFALMPARNT_AND_JAN_MAYEN: 'SFALMPARNT_AND_JAN_MAYEN',
  SLOVAKIA: 'SLOVAKIA',
  SIERRA_LEONE: 'SIERRA_LEONE',
  SAN_MARINO: 'SAN_MARINO',
  SENEGAL: 'SENEGAL',
  SOMALIA: 'SOMALIA',
  SURINAME: 'SURINAME',
  SAINT_THOMAS_AND_PRINCE: 'SAINT THOMAS AND PRINCE',
  EL_SALVADOR: 'EL SALVADOR',
  SYRIA: 'SYRIA',
  SOUAZILANDI: 'SOUAZILANDI',
  TURKS_AND_CAICOS_ISLANDS: 'TURKS AND CAICOS ISLANDS',
  CHAD: 'CHAD',
  FRENCH_SOUTHERN_AREAS: 'FRENCH SOUTHERN AREAS',
  TOGO: 'TOGO',
  THAILAND: 'THAILAND',
  TAJIKISTAN: 'TAJIKISTAN',
  TOKELAU: 'TOKELAU',
  EAST_TIMOR: 'EAST TIMOR',
  TURKMENISTAN: 'TURKMENISTAN',
  TUNISIA: 'TUNISIA',
  TONGA: 'TONGA',
  TURKEY: 'TURKEY',
  TRINITAD_AND_TOBAGO: 'TRINITAD AND TOBAGO',
  TUVALU: 'TUVALU',
  TAIWAN_PROVINCE_OF_CHINA: 'TAIWAN PROVINCE OF CHINA',
  TANZANIA: 'TANZANIA',
  UKRAINE: 'UKRAINE',
  UGANDA: 'UGANDA',
  UNITED_STATES_ELASSONA_OUTLYING_ISLANDS:
    'UNITED STATES ELASSONA OUTLYING ISLANDS',
  UNITED_STATES: 'UNITED STATES',
  URUGUAY: 'URUGUAY',
  UZBEKISTAN: 'UZBEKISTAN',
  VATICAN: 'VATICAN',
  SAINT_VINCENT_AND_THE_GRENADINES: 'SAINT_VINCENT_AND_THE_GRENADINES',
  VENEZUELA: 'VENEZUELA',
  VIRGIN_ISLANDS_BRITISH: 'VIRGIN ISLANDS BRITISH',
  VIRGIN_ISLANDS_US: 'VIRGIN ISLANDS US',
  VIETNAM: 'VIETNAM',
  VANUATU: 'VANUATU',
  GOUOLLIS_AND_FUTUNA_ISLANDS: 'GOUOLLIS AND FUTUNA ISLANDS',
  SAMOES: 'SAMOES',
  YEMEN: 'YEMEN',
  SOUTH_AFRICA: 'SOUTH AFRICA',
  ZAMBIA: 'ZAMBIA',
  ZIMBABWE: 'ZIMBABWE',
  REST: 'REST',
  ANTARCTICA: 'ANTARCTICA',
  AALAND_MISIA: 'AALAND MISIA',
  SAINT_BARTHOLOMEW: 'SAINT BARTHOLOMEW',
  BONAIRE_AND_SABA_SAINT_EFSTATHIOS: 'BONAIRE AND SABA SAINT EFSTATHIOS',
  CURACAO: 'CURACAO',
  ERITREA: 'ERITREA',
  SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS:
    'SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS',
  SAINT_MARTIN_FRENCH_PART: 'SAINT MARTIN FRENCH PART',
  SAINT_MARTIN_Dutch_part: 'SAINT MARTIN DUTCH PART',
  MAYOTTE: 'MAYOTTE',
};

export default translations;
